// extracted by mini-css-extract-plugin
export var danger = "_10-6";
export var lightPink = "_10-a";
export var medium = "_10-j";
export var nearSquare = "_10-m";
export var neutralBlue = "_10-8";
export var neutralYellow = "_10-7";
export var noCapitalize = "_10-1";
export var normal = "_10-2";
export var pill = "_10-0";
export var primary = "_10-3";
export var primaryLight = "_10-4";
export var shadow = "_10-n";
export var small = "_10-k";
export var solidBlack = "_10-i";
export var solidGreen = "_10-d";
export var solidLightBlue = "_10-f";
export var solidNavy = "_10-e";
export var solidOrange = "_10-h";
export var solidPink = "_10-g";
export var solidRed = "_10-b";
export var solidWhite = "_10-9";
export var solidYellow = "_10-c";
export var success = "_10-5";
export var xsmall = "_10-l";